import React from 'react';
import { Col } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';


import { Loading } from '../../../components';
import TransportationCard from './TransportationCard';

import {
  useTransportationJson,
  injectTransportationSearchParams,
} from '../Common';

function TransportationList(props) {
  const transportationData = useTransportationJson();
  const { queryParams: { fromLocation, toLocation }, title } = props;

  if (isEmpty(transportationData)) return <Loading />;

  const byQueryParamsSectors = bySectors(fromLocation, toLocation);
  const filteredData = transportationData.filter(byQueryParamsSectors);

  if (isEmpty(filteredData)) return <div>Sorry, no transportation services found</div>;

  const sortedData = sortBy(filteredData, [t => t.price.amount * (t.capacity || 1)]);

  return (
    <Col xs="12" lg="9">
      <div className="search-title">
        <h1 className="search-result-title">{title}</h1>
      </div>
        {sortedData.map(data => (
          <TransportationCard data={data} key={data.id} />
        ))}
    </Col>
  );
}

const bySectors = (fromLocation, toLocation) => (data) => {
  const { sectors } = data;
  const lowerCasedSectors = sectors.map(sector => sector.toLowerCase());

  const isInSectors = location => lowerCasedSectors.includes(location.toLowerCase());

  return isInSectors(fromLocation) && isInSectors(toLocation);
};

export default injectTransportationSearchParams(TransportationList);



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationList/TransportationList.js